module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-9-6e8de608.png";